<template>
    <div>
        <!-- 顶部显示那个页面 -->
        <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="margin-bottom: 10px"
        >
            <el-breadcrumb-item>首页</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 统计栏 -->
        <!-- 筛选按钮 -->
        <div style="margin-top: 15px">
            <el-date-picker
                v-model="yearMonth"
                type="month"
                placeholder="请选择需要查询的月份"
                value-format="yyyy-MM"
                @change="refreshStatisticData"
            >
            </el-date-picker>
            <el-select
                clearable
                v-if="seeSetails"
                v-model="area_id"
                @change="refreshStatisticData"
                style="width: 200px; margin-left: 5px"
                filterable
                placeholder="请选择需要查看的景区"
            >
                <el-option
                    v-for="item in scenicList"
                    :key="'scenic' + item.area_id"
                    :label="item.area_name"
                    :value="item.area_id"
                >
                </el-option>
            </el-select>
        </div>
        <el-row :gutter="20">
            <el-col :span="12">
                <div style="background-color: #fff; height: 200px">
                    <h2 style="padding: 30px 0 0 15px">本年度统计</h2>
                    <div
                        style="
                            display: flex;
                            justify-content: space-around;
                            text-align: center;
                        "
                    >
                        <div>
                            <p>{{ list.sale_year_number }}</p>
                            <p>本年度销售数量</p>
                        </div>
                        <div>
                            <p>{{ list.sale_year_cost }}</p>
                            <p>价格</p>
                        </div>
                        <div>
                            <p>{{ list.sale_year_profit }}</p>
                            <p>利润</p>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="12">
                <div style="background-color: #fff; height: 200px">
                    <h2 style="padding: 30px 0 0 15px">本月度统计</h2>
                    <div
                        style="
                            display: flex;
                            justify-content: space-around;
                            text-align: center;
                        "
                    >
                        <div>
                            <p>{{ list.sale_month_number }}</p>
                            <p>本月销售数量</p>
                        </div>
                        <div>
                            <p>{{ list.sale_month_cost }}</p>
                            <p>价格</p>
                        </div>
                        <div>
                            <p>{{ list.sale_month_profit }}</p>
                            <p>利润</p>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>

        <!-- 订单表格 -->
        <el-table
            :data="tableData"
            style="width: 100%; margin-top: 30px"
            @row-click="rowclick"
        >
            <el-table-column label="月份" prop="the_date"></el-table-column>
            <el-table-column
                label="月销售量"
                prop="sale_number"
            ></el-table-column>
            <el-table-column
                prop="package_number"
                label="月套餐销售量"
                v-if="seeInformation"
            ></el-table-column>
            <el-table-column
                prop="area_number"
                label="月景区销售量"
                v-if="seeInformation"
            ></el-table-column>
            <el-table-column label="月销售价格" prop="cost"></el-table-column>
            <el-table-column
                label="月套餐销售价格"
                prop="package_cost"
                v-if="seeInformation"
            ></el-table-column>
            <el-table-column
                label="月景区销售价格"
                prop="area_cost"
                v-if="seeInformation"
            ></el-table-column>

            <el-table-column label="月利润" prop="profit"></el-table-column>
            <el-table-column
                prop="package_profit"
                label="月套餐利润"
                v-if="seeInformation"
            ></el-table-column>
            <el-table-column
                prop="area_profit"
                label="月景区利润"
                v-if="seeInformation"
            ></el-table-column>
            <el-table-column label="操作" v-if="seeSetails">
                <!-- <template slot-scope="scope">
        </template>-->
                <template slot-scope="scope">
                    <!-- <el-button
            size="mini"
            v-if="seeInformation"
            @click="Seeviewdetails(scope.$index, scope.row)"
          >查看</el-button>-->
                    <el-button
                        size="mini"
                        @click="viewdetails(scope.$index, scope.row)"
                        >查看详情</el-button
                    >
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" v-if="seeMonthSetails">
                <template slot-scope="scope">
                    <span>
                        <el-button
                            size="mini"
                            v-if="scope.row.is_confirm == 0"
                            type="success"
                            @click="adopt(scope.$index, scope.row)"
                            >确认</el-button
                        >
                    </span>
                    <span>
                        <el-button
                            size="mini"
                            v-if="scope.row.is_confirm == 1"
                            disabled
                            type="success"
                            >已确认</el-button
                        >
                    </span>
                    <span>
                        <el-button
                            size="mini"
                            @click="exportOrders(scope.$index, scope.row)"
                            >导出订单</el-button
                        >
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div>
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pageSize"
                layout="total,  prev, pager, next, jumper"
                :total="total"
                style="
                    text-align: right;
                    margin: 0 16px 10px 0;
                    border-radius: 20px;
                "
            >
            </el-pagination>
        </div>
        <!-- 查看景区的单销售量 -->
        <el-dialog
            title="提示"
            :visible.sync="scenicDialogVisible"
            width="30%"
            :before-close="handleClose"
        >
            <el-table
                :data="scenicPrice"
                style="width: 100%"
                :cell-style="{ 'text-align': 'center' }"
            >
                <el-table-column
                    prop="package_cost"
                    label="月套餐销售价格"
                ></el-table-column>
                <el-table-column
                    prop="area_cost"
                    label=" 月景区销售价格"
                ></el-table-column>
                <el-table-column
                    prop="package_number"
                    label="月套餐销售数量"
                ></el-table-column>
                <el-table-column
                    prop="area_number"
                    label="月景区销售数量"
                ></el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="scenicDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="scenicDialogVisible = false"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
        <!--销售详情确认-->
        <el-dialog
            :visible.sync="profitDialogVisible"
            title=" 确认通知"
            width="30%"
            center
        >
            <span>您已确认结算价格和利润无误吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="profitDialogVisible = false"
                    >取 消</el-button
                >
                <el-button type="primary" @click="confirmProfit"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import qs from "qs";
export default {
    props: {
        pageSize: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            profitDialogVisible: false,
            tableData: [],
            currentPage: 1, //分页
            total: 0, //分页
            value: "",
            list: [
                { sale_year_number: "" },
                { sale_month_number: "" },
                { sale_year_cost: "" },
                { sale_month_cost: "" },
                { sale_year_profit: "" },
                { sale_month_profit: "" },
            ],
            selectedStatus: 0,
            seeSetails: false,
            seeMonthSetails: false,
            seeInformation: false,
            scenicDialogVisible: false,
            scenicPrice: [],
            yearMonth: "",
            month: "",
            the_date: "",
            id: "",
            area_id: '',
            scenicList: [],
        };
    },
    methods: {
        //确认通过
        adopt(index, row) {
            console.log(row, 6666);
            this.profitDialogVisible = true;
            this.id = row.id;
            this.the_date = row.the_date;
        },
        confirmProfit(index, row) {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            console.log(userData, 123);
            var that = this;
            var salesInfoData = {
                id: this.id,
                confirm_month: this.the_date,
                area_id: userData.area_id,
                admin_name: userData.user_name,
            };
            var salesInfoParams = {
                methodUrl: "/admin/addAreaDataRecord",
                jsonParam: qs.stringify(salesInfoData),
            };
            this.$axios.postRequest(salesInfoParams).then(
                function (res) {
                    that.profitDialogVisible = false;
                    that.findListQuery();
                },
                function (res) {
                    //失败之后处理逻辑
                    console.log("error:");
                }
            );
        },
        // 筛选按钮
        // choice (res) {
        //   console.log(res)
        //   this.selectedStatus = res[0]
        //   this.findScenicSpot()
        //   this.findListQuery()
        // },
        // 根据筛选的按钮查询首页-----未完
        //     findHome () {
        // var that = this
        // var queryData = {}
        // if (this.selectedStatus == 0) {
        //   queryData = {
        //   }
        // }
        //     },
        // 点击每行
        rowclick(index, row) {
            console.log(row, 12);
            this.month = index.the_date;
            console.log(this.month);
        },
        //查询景区
        getScenicAll () {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            var that = this;

            var salesInfoData = {
                pageindex: 1,
                pagesize: 1000
            };

            var salesInfoParams = {
                methodUrl: "admin/getScenicArea",
                jsonParam: qs.stringify(salesInfoData)
            };
            this.$axios.postRequest(salesInfoParams).then(
                function (res) {
                    //成功之后处理逻辑
                    that.scenicList = res.data.list
                },
                function (res) {
                    //失败之后处理逻辑
                    console.log("error:");
                }
            )
        },
        // 首页查询
        findScenicSpot() {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            var that = this;
            var salesInfoData = {
                role_lx: userData.role_lx,
                year: this.yearMonth,
            };
            if (userData.role_lx == 2) {
                salesInfoData.area_id = userData.area_id;
            }else if(this.area_id){
                salesInfoData.area_id = this.area_id
                salesInfoData.role_lx = 2
            }
            var salesInfoParams = {
                methodUrl: "/admin/getAreaData",
                jsonParam: qs.stringify(salesInfoData),
            };
            this.$axios.postRequest(salesInfoParams).then(
                function (res) {
                    // console.log(res)
                    //成功之后处理逻辑
                    that.list = res.data;

                    // that.total = res.data.totalcount;
                },
                function (res) {
                    //失败之后处理逻辑
                    console.log("error:");
                }
            );
        },
        // Seeviewdetails (row) {
        //   this.scenicDialogVisible = true
        //   var that = this

        //   that.findListQuery()
        // },
        handleClose() {
            this.scenicDialogVisible = false;
        },
        // 首页列表查询
        findListQuery() {
            var userData = qs.parse(sessionStorage.getItem("userData"));
            var that = this;
            var salesInfoData = {
                role_lx: userData.role_lx,
                year: this.yearMonth,
                count: true,
                pageindex: this.currentPage,
                pagesize: this.pageSize,
            };
            if (userData.role_lx == 2) {
                salesInfoData.area_id = userData.area_id;
            }else if(this.area_id){
                salesInfoData.area_id = this.area_id
            }
            var salesInfoParams = {
                methodUrl: "/admin/getTotalList",
                jsonParam: qs.stringify(salesInfoData),
            };
            this.$axios.postRequest(salesInfoParams).then(
                function (res) {
                    // console.log(res)
                    //成功之后处理逻辑
                    that.tableData = res.data.list;
                    // if (this.month == res.data.list.the_date) {
                    //   that.scenicPrice = res.data.list
                    // }
                    that.total = res.data.totalcount;
                },
                function (res) {
                    //失败之后处理逻辑
                    console.log("error:");
                }
            );
        },
        viewdetails(index, row) {
            this.$router.push({
                path: "/MonthOrder",
                query: {
                    the_date: row.the_date,
                    area_id: this.area_id,
                },
            });
            console.log(index, row);
        },
        exportOrders(index, row) {
            let userData = qs.parse(sessionStorage.getItem("userData"));
            let filterData = {
                month_date: row.the_date,
                area_id: userData.area_id,
            };
            let filterParams = {
                methodUrl: "/admin/exportOrder",
                jsonParam: qs.stringify(filterData),
            };
            this.$axios.postRequest(filterParams).then(
                (res) => {
                    //成功之后处理逻辑
                    if (res.code == 0) {
                        location.href = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.msg,
                        });
                    }
                },
                (res) => {
                    //失败之后处理逻辑
                    this.$message({
                        type: "error",
                        message: "导出失败",
                    });
                }
            );
        },
        refreshStatisticData() {
            this.currentPage = 1;
            this.findScenicSpot();
            this.findListQuery();
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.findListQuery();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.findListQuery();
        },
    },
    mounted() {
        // 获取所有景区
        this.getScenicAll()
        // this.getList();
        this.findScenicSpot();
        this.findListQuery();
        var userData = qs.parse(sessionStorage.getItem("userData"));
        if (userData.role_lx == 1) {
            this.seeSetails = true;
            this.seeInformation = false;
        } else {
            this.seeSetails = false;
            this.seeInformation = true;
            this.seeMonthSetails = true;
        }
    },
};
</script>

<style>
.header {
    width: 300px;
    height: 150px;
}
.SalesVolume {
    position: absolute;
    top: 10px;
    right: 30px;
}
.transaction {
    position: absolute;
    top: 15px;
    left: 43%;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue